import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button
} from '@mui/material';

const ConfirmProviderDetailsStep = ({
  npiData,
  details,
  errors,
  onDetailChange,
  onBack,
  onContinue
}) => (
  <Box sx={{ maxWidth: 400 }}>
    <Typography variant="h6" gutterBottom>
      Confirm your details
    </Typography>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      Please review and update your information below.
    </Typography>
    {npiData && (
      <Box sx={{ mt: 2 }}>
        <TextField
          fullWidth
          label="NPI Number"
          value={npiData.number}
          disabled
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Name Prefix"
          value={details.name_prefix}
          onChange={onDetailChange('name_prefix')}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="First Name"
          value={details.first_name}
          onChange={onDetailChange('first_name')}
          error={!!errors.first_name}
          helperText={errors.first_name}
          required
          data-error={!!errors.first_name}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Middle Name"
          value={details.middle_name}
          onChange={onDetailChange('middle_name')}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Last Name"
          value={details.last_name}
          onChange={onDetailChange('last_name')}
          error={!!errors.last_name}
          helperText={errors.last_name}
          required
          data-error={!!errors.last_name}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Name Suffix"
          value={details.name_suffix}
          onChange={onDetailChange('name_suffix')}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Credential"
          value={details.credential}
          onChange={onDetailChange('credential')}
          sx={{ mb: 2 }}
        />
        <Typography variant="subtitle1" sx={{ mb: 2, textAlign: 'left' }}>
          Contact information
        </Typography>
        <TextField
          fullWidth
          label="Phone Number"
          value={details.provider_phone}
          onChange={onDetailChange('provider_phone')}
          error={!!errors.provider_phone}
          helperText={errors.provider_phone}
          required
          data-error={!!errors.provider_phone}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          label="Fax Number"
          value={details.provider_fax}
          onChange={onDetailChange('provider_fax')}
          error={!!errors.provider_fax}
          helperText={errors.provider_fax}
          required
          data-error={!!errors.provider_fax}
          sx={{ mb: 2 }}
        />
      </Box>
    )}
    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
      <Button variant="outlined" onClick={onBack}>
        Back
      </Button>
      <Button variant="contained" onClick={onContinue}>
        Continue
      </Button>
    </Box>
  </Box>
);

export default ConfirmProviderDetailsStep;
